<script>
import moment from 'moment'
import Detail from './Detail'

export default {
  extends: Detail,
  name: 'contentCreate',
  data () {
    return {
      bttons: [
        {
          name: '1',
          label: '存为初稿',
          icon: 'baocun',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '2',
          label: '发布',
          icon: 'fabu',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '3',
          label: '存为草稿',
          icon: 'cunweicaogao',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        },
        {
          name: '12',
          label: '提交审核',
          icon: 'shenhe',
          disabled: !this._checkPermission('/admin/contentext', 'PUT')
        }
      ]
    }
  },
  methods: {
    moment,
    fetchContentDetail () {
      const that = this
      this.loading = true
      this.$request.fetchContentPlus(this.contentId).then(res => {
        if (res.code === 200) {
          let dataField = {
            modelId: this.contentId,
            modelName: this.$route.query.modelName || '',
            channelId: this.channelId
          }
          Object.values(res.data.enableJson).forEach(item => {
            if (item instanceof Array && item.length) {
              item.forEach(d => {
                if (d.value.type === 'datetime' && d.value.isDefaultNow) {
                  dataField[d.value.name] = that.moment().format('YYYY-MM-DD HH:mm:ss')
                } else {
                  dataField[d.value.name] = d.value.defaultValue
                }
              })
            }
          })
          this.detail = {
            renderingField: res.data.enableJson,
            dataField
          }
          this.setForm()
          this.setDefaultContentTab()
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSubmit (e, btn) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          this.$request.fetchContentCreate(this.getFormData).then(res => {
            if (res.code === 200) {
              this._messageSuccess('create')
              this.removeTab(this.$route.fullPath)
              this.$routerLink('/content/index', 'list')
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    setHeaderBths (status) {
      let arr = []
      if (status) {
        // 工作流
        arr = ['12', '1', '3']
      } else {
        // 非工作流
        arr = ['1', '2', '3']
      }
      this.headers = arr.map(v => {
        return this.bttons.find(d => d.name === v)
      })
    }
  },
  watch: {
    'form.channelId': function (newData) {
      if ('viewControl' in this.form || 'allowComment' in this.form) {
        if (newData) {
          this.$request.fetchChannelDefaults(newData).then(res => {
            if (res.code === 200) {
              if ('viewControl' in this.form) {
                this.form.viewControl = res.data.viewControl
              }
              if ('allowComment' in this.form) {
                this.form.allowComment = res.data.allowComment
              }
            }
          })
        }
      }
    }
  }
}
</script>
